import { useStaticQuery, graphql } from 'gatsby';


export const Art = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query artPosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "art" }) {
						nodes {
							title
							colourFeatureImage
							link
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
								mediaItemUrl
								}
							}    										
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};
